import { stringify } from 'query-string'

function list(pageType, httpClient) {
  return httpClient({
    url: `/quick-filters?${stringify({ pageType })}`,
    method: 'GET',
  }).then((response) => response.data)
}

function create(payload, httpClient) {
  return httpClient({
    url: '/quick-filters',
    method: 'POST',
    data: JSON.stringify(payload),
  }).then((response) => response.data)
}

function update(id, payload, httpClient) {
  return httpClient({
    url: `/quick-filters/${id}`,
    method: 'PUT',
    data: JSON.stringify(payload),
  }).then((response) => response.data)
}

function remove(id, httpClient) {
  return httpClient({
    url: `/quick-filters/${id}`,
    method: 'DELETE',
  })
}

function setDefault(id, httpClient) {
  return httpClient({
    url: `/quick-filters/${id}/set-default`,
    method: 'PUT',
  })
}

function clearDefault(pageType, httpClient) {
  return httpClient({
    url: `/quick-filters/default?${stringify({ pageType })}`,
    method: 'DELETE',
  })
}

export default {
  list,
  create,
  update,
  remove,
  setDefault,
  clearDefault,
}
